var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 4.66666C26.6673 4.31304 26.5268 3.9739 26.2768 3.72386C26.0267 3.47381 25.6876 3.33333 25.334 3.33333H18.07C17.7237 2.54309 17.1546 1.87086 16.4324 1.39883C15.7102 0.926796 14.8661 0.675415 14.0033 0.675415C13.1405 0.675415 12.2964 0.926796 11.5742 1.39883C10.852 1.87086 10.2829 2.54309 9.93665 3.33333H2.66732C2.3137 3.33333 1.97456 3.47381 1.72451 3.72386C1.47446 3.9739 1.33398 4.31304 1.33398 4.66666V30C1.33398 30.3536 1.47446 30.6928 1.72451 30.9428C1.97456 31.1929 2.3137 31.3333 2.66732 31.3333H25.334C25.6876 31.3333 26.0267 31.1929 26.2768 30.9428C26.5268 30.6928 26.6673 30.3536 26.6673 30V4.66666Z",
    fill: "#C7E0F4",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 27.3334H17.4406C17.8256 27.3332 18.206 27.2497 18.5556 27.0886C18.9052 26.9275 19.2158 26.6926 19.466 26.4L22.0246 23.4147C22.438 22.9316 22.6658 22.3172 22.6673 21.6814V7.33337H5.33398V27.3334Z",
    fill: "#E3E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 24.6493L22.6527 7.32935H5.33398V24.6493Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 22H10.0007M5.33398 27.3334H17.4407C17.8256 27.3332 18.206 27.2497 18.5556 27.0886C18.9052 26.9275 19.2158 26.6926 19.466 26.4L22.0246 23.4147C22.438 22.9316 22.6658 22.3172 22.6673 21.6814V7.33337H5.33398V27.3334ZM18.6673 11.3334H12.6673H18.6673ZM9.33398 11.3334H10.0007H9.33398ZM18.6673 16.6667H12.6673H18.6673ZM9.33398 16.6667H10.0007H9.33398ZM16.6673 22H12.6673H16.6673Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIcon);
export default __webpack_public_path__ + "static/media/total-icon.2cc0c0cb.svg";
export { ForwardRef as ReactComponent };